import { create } from "zustand";
import axios from "axios";

const episodeStore = create((set, get) => ({
    episode: null,

    episodeForm: {
        seriesId: "",
        seasonNumber: "",
        episodeNumber: "",
        title: "",
        description: "",
        releaseDate: "",
        image: "",
    },

    fetchEpisode: async () => {
        // Fetch the episodes
        const res = await axios.get("/episode");

        // Set to state
        set({ episode: res.data.episodes });
    },

    fetchEpisodesBySeries: async (seriesId) => {
        // Fetch the episodes
        const res = await axios.get("/episode/series/" + seriesId);

        // Set to state
        set({ episode: res.data.episodes });
        //return res.data.episodes;
    },

    // fetchEpisodesBySeries: async (id) => {
    //     const res = await axios.get(`/episode/series/${id}`);
    //     set({ episodes: res.data.episodes });
    // },
    
    // getEpisodesBySeries: async (id) => {
    //     // // Fetch the episodes
    //     // const res = await axios.get(`/episode/series/${id}`); //seriesId
    //     // console.log("1: " + res.data.episodes);
    //     // console.log("2: " + res.data.episodes[0].title);
    //     // return res.data.episodes;
    //      return get().episodes?.filter(ep => ep.seriesId === id);
    // },

    tvdbGetEpisodesBySeries: async (id) => {
        // Fetch the episodes
        const res = await axios.get(`/api/episode/series/${id}`); //tvdbId
        return res;
    },

    populateEpisodeForm: (data, seriesId) => {
        try {
            set(state => ({
                episodeForm: {
                    ...state.episodeForm,
                    seriesId: seriesId || "", 
                    seasonNumber: data.seasonNumber || "", 
                    episodeNumber: data.number || "", 
                    title: data.name || "", 
                    description: data.overview || "", 
                    releaseDate: data.aired || "", 
                    image: "https://artworks.thetvdb.com" + data.image || "",
                }
            }));
        } catch (err) {
            console.log("Error at populateEpisodeForm");
        }
    },

    createEpisode: async (e) => {
        try {
            const { episodeForm } = episodeStore.getState();
            const res = await axios.post("/episode", episodeForm);

            // Clear the form fields
            set({
                episodeForm: {
                    seasonNumber: "",
                    episodeNumber: "",
                    title: "",
                    description: "",
                    releaseDate: "",
                    image: "",
                },
            });

            return res;
        } catch (err) {
            console.log("Error at createEpisode");
        }
    },

}));

export default episodeStore;